"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MegaMenu = void 0;
const react_1 = __importStar(require("react"));
const styled_bootstrap_grid_1 = require("styled-bootstrap-grid");
const react_router_dom_1 = require("react-router-dom");
const react_redux_1 = require("react-redux");
const LinkAsButton_1 = __importDefault(require("../../../LinkAsButton"));
const Promo_1 = __importDefault(require("../../../Promo"));
const Types_1 = require("Types");
const Typography_1 = require("../../../UI/Typography");
const Utils_1 = require("@/Utils");
const megamenu_1 = require("@/Redux/Actions/megamenu");
const Hooks_1 = require("@/Hooks");
const Theme_1 = require("@/Theme");
const style = __importStar(require("./styled"));
const spa_core_1 = require("@episerver/spa-core");
const MegaMenu = ({ heading, secondLevelItems, promoRef, headingLink }) => {
    const [newPromo, setNewPromo] = (0, react_1.useState)();
    const isMegaMenuOpen = (0, react_redux_1.useSelector)((state) => state.menuToggle.isOpen);
    const dispatch = (0, react_redux_1.useDispatch)();
    const { width } = (0, Hooks_1.useWindowSize)();
    const history = (0, react_router_dom_1.useHistory)();
    const cmsState = (0, spa_core_1.useCmsState)();
    const isForceReloadLink = `${!(cmsState === null || cmsState === void 0 ? void 0 : cmsState.iContent)}`;
    (0, react_1.useEffect)(() => {
        return history.listen(() => {
            dispatch((0, megamenu_1.setIsMegaMenuOpen)(false));
        });
    }, [history, megamenu_1.setIsMegaMenuOpen]);
    const renderCols = () => {
        const structuredLevels = (0, Utils_1.getStructuredMegamenuItems)(secondLevelItems);
        const columns = newPromo ? 4 : 3;
        return structuredLevels.map((item, i) => {
            if (item.length > 0) {
                return (react_1.default.createElement(style.Col, { lg: columns, md: columns + 1, key: i, columns: width < Theme_1.theme.breakpoints.lg ? 4 : columns }, item.map((secondItem, x) => (react_1.default.createElement("div", { key: x },
                    react_1.default.createElement(style.SecondTitle, { type: Typography_1.Types.NAV_MEGA_LVL2, hasChildren: secondItem.thirdLevelItems.length > 0 },
                        react_1.default.createElement(style.Link, { href: secondItem.uri, target: secondItem.target, "data-force-reload": isForceReloadLink, onClick: () => dispatch((0, megamenu_1.setIsMegaMenuOpen)(false)) }, secondItem.title)),
                    secondItem.thirdLevelItems.map((thirdItem, x) => (react_1.default.createElement(style.ThirdTitle, { key: x, type: Typography_1.Types.NAV_MEGA_LVL3 },
                        react_1.default.createElement(style.Link, { href: thirdItem.uri, target: thirdItem.target, "data-force-reload": isForceReloadLink, onClick: () => dispatch((0, megamenu_1.setIsMegaMenuOpen)(false)) }, thirdItem.title)))))))));
            }
            else {
                return null;
            }
        });
    };
    return (react_1.default.createElement(style.MegaMenu, { isMegaMenuOpen: isMegaMenuOpen },
        react_1.default.createElement(style.MenuItems, { isMegaMenuOpen: isMegaMenuOpen },
            react_1.default.createElement(style.TopRow, null,
                react_1.default.createElement(LinkAsButton_1.default, { "data-force-reload": isForceReloadLink, variant: Types_1.LinkAsButtonVariants.LINK_BUTTON_BIG, href: headingLink, onClick: () => dispatch((0, megamenu_1.setIsMegaMenuOpen)(false)), hoverColor: Theme_1.theme.palette.LIGHT_BLACK }, heading)),
            react_1.default.createElement(style.Row, null,
                react_1.default.createElement(styled_bootstrap_grid_1.Col, { lg: newPromo ? 9 : 12 },
                    react_1.default.createElement(styled_bootstrap_grid_1.Row, null, renderCols())),
                promoRef && (react_1.default.createElement(Promo_1.default, { promoRef: promoRef, setNewPromo: setNewPromo, newPromo: newPromo, linkFunction: () => dispatch((0, megamenu_1.setIsMegaMenuOpen)(false)) }))))));
};
exports.MegaMenu = MegaMenu;
exports.default = exports.MegaMenu;
